<template> 
    <el-dialog 
        :visible.sync="config.dialogVisible" 
        width="800"
        height="400"
        :close-on-click-modal="false"
        append-to-body 
        :title="config.type === 'person'?'人员选择':config.type === 'dept'?'部门选择':'角色选择'">
        <div style="display: flex;">
            <div style="width: 50%;height: 400px;overflow-y: auto;">
                <div class="search-wrap" style="margin-top: 16px;margin-right: 26px;margin-bottom: 16px;">
                    <el-input class="prepend-css" v-model="filterText" placeholder="搜索" size="mini">
                        <el-button slot="prepend" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
                <div class="tree-div" v-if="config.type === 'person'">
                    <el-tree
                        ref="allMembersTree"
                        :data="memberDeptData"
                        node-key="value"
                        :props="defaultProps"
                        :default-expand-all="false"
                        :check-strictly="true"
                        :is-disabled="(data) => data.dataType !== 'staff'"
                        :filter-node-method="filterNode"
                        >
                        <span slot-scope="{ node, data }" style="width: 100%;" >
                            <div style="display: flex; align-items: center;justify-content: space-between;" v-if="multiple">
                                <!-- 可点击的标签 -->
                                <span 
                                    style="font-size: 12px; margin-right: 8px; cursor: pointer;"
                                   @click.stop="()=>{toggleCheckbox(data, node)}"
                                >
                                    {{ data.label }}
                                </span>
                                <el-checkbox 
                                    v-model="node.checked" 
                                    v-if="multiple"
                                    @change="(val) => handleCheckChange(data, val)"
                                ></el-checkbox>
                            </div>
                            <div v-else style="display: flex; align-items: center;justify-content: space-between;" @click.stop="()=>{toggleCheckbox(data, node)}">
                                <!-- 可点击的标签 -->
                                <span 
                                    style="font-size: 12px; margin-right: 8px; cursor: pointer;"
                                >
                                    {{ data.label }}
                                </span>
                                <div v-if="data.dataType === 'staff'" @click.stop="toggleCheckbox(data, node)">
                                    <i class="el-icon-success"
                                     v-if="data.id == selectedValues[0]"
                                     style="color: #b40005!important;font-size: 14px;"></i>
                                    <div style="
                                        border: 1px solid #DCDFE6;
                                        border-radius: 100%;
                                        width: 14px;
                                        height: 14px;
                                        background-color: #FFF;
                                        cursor: pointer;
                                        box-sizing: border-box;"
                                        v-else>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </el-tree>
                </div>
                <!-- 部门选择 -->
                <div class="tree-div" v-if="config.type === 'dept'"">
                        <el-tree
                            ref="allDepartmentsTree"
                            :data="allDepartments"
                            :props="deptProps"
                            node-key="deptId"
                            :check-strictly="true"
                            @check-change="handleCheckChange"
                            :filter-node-method="filterNodeDept">
                            <span slot-scope="{ node, data }" style="width: 100%;">
                                <div style="display: flex; align-items: center;justify-content: space-between;">
                                    <!-- 可点击的标签 -->
                                    <span 
                                        style="font-size: 12px; margin-right: 8px; cursor: pointer;"
                                        @click.stop="toggleCheckbox(data, node)"
                                    >
                                        {{ data.deptName }}
                                    </span>
                                    <el-checkbox 
                                        v-model="node.checked" 
                                        v-if="multiple"
                                        @change="(val) => handleCheckChange(data, val)"
                                    ></el-checkbox>
                                    <div v-if="!multiple"@click.stop="toggleCheckbox(data, node)">
                                        <i class="el-icon-success"
                                        v-if="data.deptId == selectedValues[0]"
                                        style="color: #b40005!important;font-size: 14px;"></i>
                                        <div style="
                                            border: 1px solid #DCDFE6;
                                            border-radius: 100%;
                                            width: 14px;
                                            height: 14px;
                                            background-color: #FFF;
                                            cursor: pointer;
                                            box-sizing: border-box;"
                                            v-else>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </el-tree>
                </div>
                
                <!-- 角色选择 -->
                 <div class="tree-div" v-if="config.type === 'role'"">
                        <el-tree
                            ref="allRolesTree"
                            v-if= "config.type === 'role'""
                            :data="allRoles"
                            :props="roleProps"
                            show-checkbox
                            node-key="roleId"
                            default-expand-all
                            @check-change="handleCheckChange">
                        </el-tree>
                </div>
            </div>
            <div style="width: 50%;height: 400px;overflow-y: auto;padding: 0 20px;border-left: 1px solid #efefef;">
                <div style="display: flex;justify-content: space-between;margin-top: 20px;font-size: 12px;">
                    <div style="margin-bottom: 16px;">
                        已选{{ config.type === 'person'?'人员':config.type === 'dept'?'部门':'角色' }}:
                        <span>{{ selectedValues.length }}</span>
                    </div>
                    <div @click="handleAllClose" class="cursor_point">清空所选</div>
                </div>
                <div v-if="config.type === 'person'">
                    <div class="person-item" v-for="item in selectedValues" :key="item">
                        <div style="display: flex;">
                            <div v-if="getAllByValue(item, config.type).picUrl">
                                <el-image style="height: 30px; width: 30px;border-radius: 50%;margin-right: 16px;" :src="global.BASE_URL + getAllByValue(item, config.type).picUrl"></el-image>
                            </div>
                            <div v-else class="person-item_name" :style="{'background-color':color(getAllByValue(item, config.type).nameCn)}">
                                {{ getAllByValue(item, config.type).nameCn.slice(0,1) }}
                            </div>
                            <div class="person-item_detail">
                                <div>{{ getAllByValue(item, config.type).nameCn }}<span v-show="getAllByValue(item, config.type).positionName"> - {{ getAllByValue(item, config.type).positionName }}</span></div>
                                <div class="item_detail--dept">{{ getAllByValue(item, config.type).deptName }}</div>
                            </div>
                        </div>
                        <div class="person-item_close">
                            <i class="el-icon-circle-close cursor_point" @click="handleTagClose(item)"></i>
                        </div>
                    </div>
                </div>
                <div v-else-if="config.type === 'dept'">
                    <div class="dept-item" v-for="item in selectedValues" :key="item">
                        <div style="display: flex;">
                            <div class="dept-item_detail">
                                <div>{{ getAllByValue(item, config.type).deptName }}</div>
                            </div>
                        </div>
                        <div class="dept-item_close">
                            <i class="el-icon-circle-close cursor_point" @click="handleTagClose(item)"></i>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <el-tag
                        v-for="item in selectedValues"
                        :key="item"
                        closable
                        size="mini"
                        style="margin-right: 10px;margin-top: 10px;"
                        @close="handleTagClose(item)">
                        <span v-if="config.type === 'dept'">
                            {{ getLabelByValue(item, config.type) }}
                        </span>
                        <span v-else>
                            {{ getAllByValue(item, config.type) }}
                        </span>
                    </el-tag>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="config.dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmData">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name:'personDept',
    props:{
        config:{},
        initData: '',
        users: Array,
        multiple: true,
        isSalesType:false,
        showSelf: {
            type:Boolean,
            default: true,  
        },
    },
    computed:{
        title() {
            let title = ''
            if(this.config.type === 'person') {
                title = '人员选择';
            } else if (this.config.type === 'dept') {
                title = '部门选择';
            } else if (this.config.type === 'role') {
                title = '角色选择';
            } else if (this.config.type === 'salesman') {
                title = '业务员选择';
            }
            return title
        }
    },
    data(){
        return {
            memberDeptData:[],
            allMemebers: [],
            allDepartments: [],
            allRoles: [],
            deptProps: {
                children: "children",
                label: "deptName",
                id: 'deptId'
            },
            defaultProps: {
                children: "children",
                label: "label",
                id: 'value'
            },
            roleProps: {
                children: "children",
                label: "roleName",
                id: 'roleId'
            },
            selectedValues: [],
            filterText:'',
        }
    },
    created(){
        if(this.config.type === 'role'){
            this.getRoleOptions()
        }else{
            this.getDeptOptions()
        }
        if(this.initData){
            this.setData()
        }
    },
    computed: {
        // memberDeptData() {
        //     console.log(this.users,'user',this.allDepartments)
        //     return this.transformTreeData(this.allDepartments, 'deptName', 'deptId');
        // },
        nameKey() {
            if (this.config.type == 'person') {
                return 'value';
            }
            if (this.config.type  == 'role') {
                return 'roleId';
            } else if (this.config.type  == 'dept') {
                return 'deptId';
            }
            return 'id';
        },
        // 弹出窗树选择器选择项id字段名
        idKey() {
            if (this.config.type == 'person') {
                return 'value';
            }
            if (this.config.type == 'role') {
                return 'roleId';
            } else if (this.config.type == 'dept') {
                return 'deptId';
            }
            return 'id';
        },
    },
    watch: {
        filterText(val) {
            if (this.config.type == 'person') {
                this.$refs.allMembersTree.filter(val);
            }else if (this.config.type == 'role') {
                this.$refs.allRolesTree.filter(val);
            } else if (this.config.type == 'dept') {
                this.$refs.allDepartmentsTree.filter(val);
            }
            
        },
    },
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        filterNodeDept(value, data) {
            console.log(value,data,'dataFIliter')
            if (!value) return true;
            return data.deptName.indexOf(value) !== -1;
        },
        color (name) {
            console.log(name,'name  ')
            let num = ''
            //循环人名前两位，把汉字转换成字符的 Unicode 编码，生成10位数字
            for (let i = 0; i < 2; i++) {
                num += parseInt(name[i].charCodeAt(0), 10)
            }
            //经过尝试，使用rgb格式颜色，手动固定R色值，给G和B值随机，最容易控制出想要的色彩
            //取任意两位数字X2,让颜色尽可能拉开差距，并保证不超过255
            return 'rgb(80,' + (num.slice(3, 5) * 2) + ',' + (num.slice(6, 8) * 2) + ')'
        },
        buildDeptTreeWithUsers(deptTree, userList) {
            // 首先创建一个部门ID到部门的映射，方便快速查找
            const deptMap = {};
            
            // 递归遍历部门树，建立映射
            // 递归遍历部门树，添加 label 和 value，并建立映射
            function processDeptNodes(nodes) {
                nodes.forEach(dept => {
                // 添加 label 和 value 属性
                dept.label = dept.deptName;  // 显示名称
                dept.value = dept.deptId;    // 值通常使用ID
                
                // 将部门存入映射表
                deptMap[dept.deptId] = dept;
                
                // 如果有子部门，递归处理
                if (dept.children && dept.children.length > 0) {
                    processDeptNodes(dept.children);
                }
                });
            }
            
            // 初始化处理
            processDeptNodes(deptTree);
            // 将用户分配到对应的部门
            console.log(this.showSelf,'showSelf')
            userList.forEach(user => {
                const dept = deptMap[user.deptId];
                if (dept) {
                    // 传入showSelf为false时过滤掉自己
                    if(!this.showSelf && JSON.parse(localStorage.getItem("user")).userInfoId === user.id){
                        console.log('hidden')
                        return ;
                    }
                    // 只添加需要的用户信息
                    if(dept.children){
                        dept.children.push({
                            label: user.nameCn,
                            value: user.id,
                            id: user.id,
                            dataType: 'staff',
                            code: user.userCode,
                        })
                    }else{
                        dept.children = []
                        dept.children.push({
                            label: user.nameCn,
                            value: user.id,
                            id: user.id,
                            dataType: 'staff',
                            code: user.userCode,
                        })
                    }
                }
            });
            console.log(deptTree,deptMap)
            return deptTree;
        },
        setData(){
            this.selectedValues = this.initData.split(',')
            console.log(this.initData.split(','),'this.initData.split(',')',this.initData)
            setTimeout(()=>{
                this.updateTreeSelection();
            },2000)
        },
        transformTreeData(treeData, labelKey = 'name', valueKey = 'id') {
            return treeData.map((node) => {
                const formattedNode = {
                label: node[labelKey], // 设置 label
                value: node[valueKey], // 设置 value
                dataType: node.dataType ? node.dataType : 'dept',
                    ...node
                };
                // 递归处理子节点
                if (node.children && node.children.length > 0) {
                    formattedNode.children = this.transformTreeData(node.children, labelKey, valueKey);
                }
                return formattedNode;
            });
        },
        /**
         * 查询部门下拉树结构
         */
        getDeptOptions() {
            let url = `${this.global.BASE_URL}/msi/base/info/dept/findAllBaseDeptTree`;
            if(this.isSalesType){
                url = `${this.global.BASE_URL}/msi/base/info/dept/findAllBaseDeptTreeYxx`;
            }
            return this.$axios.post(url, { asp: JSON.parse(localStorage.getItem("user")).asp, data: { categoryCode: "dept" } })
                .then(response => {
                    this.allDepartments = response.data.data;
                    console.log(this.allDepartments,'this.allDepartments')
                    if(this.config.type === 'person'){
                        this.memberDeptData = this.buildDeptTreeWithUsers(this.allDepartments, this.users);
                        console.log('this.memberDeptData',this.memberDeptData)
                    }
                });
        },
        /**
         * 查询角色下拉树结构
         */
        getRoleOptions() {
            let data = {
                data: {},
                pageIndex: 0,
                pageSize: 9999,
            };
            let url = `${this.global.BASE_URL}/msi/base/info/role/findAllRole`;
            this.$axios.post(url, data).then(response => {
                this.allRoles = response.data.data;
            });
        },
        renderTreeNode(h, { node, data, store }) {
            return h('span', [
                data.dataType === 'staff' ? h('el-checkbox', {
                props: {
                    value: node.checked
                },
                on: {
                    change: () => store.setChecked(node.data, !node.checked)
                }
                }) : null,
                h('span', [node.label])
            ]);
        },
        handleDeptNodeClick(data, node) {
            if (data.dataType === 'staff') {
                console.log(data, node, 'node')
                if(node){
                    this.$refs.allMembersTree.setChecked(node.data, !node.checked)
                }
            }
        },
        updateTreeSelection() {
            const treeRefs = ['allMembersTree', 'allDepartmentsTree', 'allRolesTree'];
            let tempString = [...this.selectedValues];
            treeRefs.forEach(ref => {
                const tree = this.$refs[ref];
                if (tree) {
                tree.setCheckedKeys([]); // 先将所有勾选去掉
                tempString.forEach(value => {
                    const node = this.findNodeByLabel(tree, value);
                    console.log(node,'updateTreeSelection')
                    if (node) {
                        tree.setChecked(node[this.nameKey], true, true);
                    }
                });
                }
            });
        },
        //通过tag显示值找到左边树节点
        findNodeByLabel(tree, label) {
            let result = null;
            console.log(this.nameKey,tree.data)
            const traverse = (nodes) => {
                
                for (let node of nodes) {
                    if (node[this.nameKey] == label) {
                        result = node;
                        return;
                    }
                    if (node.children) {
                        traverse(node.children);
                    }
                }
            };
            traverse(tree.data);
            return result;
        },
        toggleCheckbox(data, node) {
            if(this.config.type === 'person' && !this.multiple && data.dataType !== 'staff'){
                return ;
            }
            // 人员选择点击人员
            if (this.config.type === 'person') {
                node.checked = !node.checked;
                this.handleCheckChange(data, node.checked);
            }
            if (this.config.type === 'dept') {
                console.log('toggleCheckbox')
                node.checked = !node.checked;
                this.handleCheckChange(data, node.checked);
            }
        },
        handleCheckChange(data, checked) {
            console.log(data, checked,'nameKey',this.selectedValues)
            if (checked) {
                // 兼容单选，在单选时自动清空
                if(!this.multiple && (this.config.type === 'person' || this.config.type === 'dept')){
                    console.log('handleAllClose')
                    this.handleAllClose()
                }
                if (!this.selectedValues.includes(data[this.nameKey].toString())) {
                    // 人员多选选择部门时做特殊处理
                    if(this.multiple && this.config.type === 'person' && data.dataType !== 'staff'){
                        if(data.children.length > 0){
                            data.children.forEach(item => {
                                if(item.dataType === 'staff'){
                                    console.log(item,'this.multiple && this.config.type ===',checked)
                                    // 勾选树
                                    this.$refs.allMembersTree.setChecked(item, checked)
                                    // 给右侧数组增加数据
                                    this.handleCheckChange(item,checked)
                                }
                            })
                        }
                    }else{
                        this.selectedValues.push(data[this.nameKey].toString());
                    }
                }
            } else {
                // 人员多选选择部门时做特殊处理
                if(this.multiple && this.config.type === 'person' && data.dataType !== 'staff'){
                    if(data.children.length > 0){
                        data.children.forEach(item => {
                            if(item.dataType === 'staff'){
                                // 取消勾选树
                                this.$refs.allMembersTree.setChecked(item, checked)
                                // 触发取消每一个勾选
                                this.handleCheckChange(item,checked)
                            }
                        })
                    }
                }else if(this.multiple && this.config.type === 'person' && data.dataType === 'staff'){
                    const index = this.selectedValues.indexOf(data[this.nameKey].toString());
                    if (index > -1) {
                        this.selectedValues.splice(index, 1);
                    }
                    // 通过data.value去获取当前人员节点的上属部门节点，并取消勾选
                    const currentNode = this.$refs.allMembersTree.getNode(data.value);
                    if (currentNode.parent) {
                        console.log('上一节点数据:', currentNode.parent.data);
                        this.$refs.allMembersTree.setChecked(currentNode.parent.data, checked)
                    }
                }else{
                    const index = this.selectedValues.indexOf(data[this.nameKey].toString());
                    if (index > -1) {
                        this.selectedValues.splice(index, 1);
                    }
                }  
            }
        },
        handleTagClose(tag) {
            const index = this.selectedValues.indexOf(tag);
            if (index > -1) {
                this.selectedValues.splice(index, 1);
                this.uncheckTreeNode(tag);
            }
        },
        handleAllClose(){
            this.selectedValues = []
            const treeRefs = ['allMembersTree', 'allDepartmentsTree', 'allRolesTree'];
            treeRefs.forEach(ref => {
                const tree = this.$refs[ref];
                if (tree) {
                    tree.setCheckedKeys([]); // 先将所有勾选去掉
                }
            });
        },
        //通过取消右边的tag同步取消左边的树的勾选
        uncheckTreeNode(tag) {
            const treeRefs = ['allMembersTree', 'allDepartmentsTree', 'allRolesTree'];
            treeRefs.forEach(ref => {
                const tree = this.$refs[ref];
                if (tree) {
                    const node = this.findNodeByLabel(tree, tag);
                    console.log(node,'uncheckTreeNode')
                    if (node) {
                        tree.setChecked(node[this.idKey], false, true);
                    }
                    // 人员多选取消时做特殊处理，将上级部门取消勾选
                    if(this.multiple && this.config.type === 'person'){
                        const currentNode = tree.getNode(node);
    
                        if (currentNode.parent) {
                            console.log('上一节点:', currentNode.parent.data);
                            tree.setChecked(currentNode.parent.data, false)
                        }
                    }
                }
            });
        },
        getLabelByValue(value, type) {
            let allOptions;
            let valueKey = 'value';
            let nameKey = 'label';
            if (type === 'person') {
                allOptions = this.users;
                valueKey = 'id';
                nameKey = 'nameCn';
            } else if (type === 'dept') {
                allOptions = this.allDepartments;
                valueKey = 'deptId';
                nameKey = 'deptName';
            } else if (type === 'role') {
                allOptions = this.allRoles;
                valueKey = 'roleId';
                nameKey = 'roleName';
            } else {
                return value;
            }
            const findLabel = (nodes, value) => {
                for (let node of nodes) {
                    if (node[valueKey] == value) {
                        return node[nameKey];
                    }
                    if (node.children && node.children.length > 0) {
                        const label = findLabel(node.children, value);
                        if (label) {
                            return label;
                        }
                    }
                }
                return null;
            };
            return findLabel(allOptions, value) || value;
        },

        getCodeByValue(value, type) {
            let allOptions;
            let valueKey = 'value';
            let nameKey = 'label';
            if (type === 'person') {
                allOptions = this.users;
                valueKey = 'id';
                nameKey = 'userCode';
            } else if (type === 'dept') {
                allOptions = this.allDepartments;
                valueKey = 'deptId';
                nameKey = 'deptCode';
            } else if (type === 'role') {
                allOptions = this.allRoles;
                valueKey = 'roleId';
                nameKey = 'roleCode';
            } else {
                return value;
            }
            const findCode = (nodes, value) => {
                for (let node of nodes) {
                    if (node[valueKey] == value) {
                        return node[nameKey];
                    }
                    if (node.children && node.children.length > 0) {
                        const label = findCode(node.children, value);
                        if (label) {
                            return label;
                        }
                    }
                }
                return null;
            };
            return findCode(allOptions, value) || value;
        },
        getAllByValue(value, type) {
            let allOptions;
            let valueKey = 'value';
            let nameKey = 'label';
            if (type === 'person') {
                allOptions = this.users;
                valueKey = 'id';
                nameKey = 'userCode';
            } else if (type === 'dept') {
                allOptions = this.allDepartments;
                valueKey = 'deptId';
                nameKey = 'deptCode';
            } else if (type === 'role') {
                allOptions = this.allRoles;
                valueKey = 'roleId';
                nameKey = 'roleCode';
            } else {
                return value;
            }
            const findCode = (nodes, value) => {
                for (let node of nodes) {
                    if (node[valueKey] == value) {
                        return node;
                    }
                    if (node.children && node.children.length > 0) {
                        const foundNode = findCode(node.children, value);
                        if (foundNode) {
                            return foundNode;
                        }
                    }
                }
                return null;
            };
            return findCode(allOptions, value) || value;
        },
        confirmData(){
            if(!this.multiple && this.selectedValues.length > 1){
                this.$message.warning('该功能为单选，请勿选择多个数据')
                return ;
            }
            if (this.config.type) {
                let idData = ''
                let nameData = ''
                let allData = []
                idData = this.selectedValues.join(',');
                nameData = this.selectedValues.map(value => this.getLabelByValue(value, this.config.type)).join(',');
                console.log(this.selectedValues,'this.selectedValues')
                allData = this.selectedValues.map(value =>{
                    let allData = this.getAllByValue(value, this.config.type)
                    let t = {
                        id: value,
                        name: this.getLabelByValue(value, this.config.type),
                        code: this.getCodeByValue(value, this.config.type),
                        mobile:allData.mobile,
                        deptId: allData.deptId,
                        deptName: allData.deptName,
                        deptCode: allData.deptCode,
                        positionName: allData.positionName,
                        positionId: allData.positionId,
                        positionCode: allData.positionCode,
                        picUrl: allData.picUrl,
                        sex: allData.sex,
                        birthday: allData.birthday,
                    }
                    return t
                })
                this.$emit('choiceData',idData, nameData,allData)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.el-tag {
    color: #b40005;
    background-color: #ff9d8a33;
    border-color: #ff9d8a33;
}
::v-deep .el-tree-node__content {
    font-size: 12px !important;
}
::v-deep .el-tag__close {
    color: #b40005 !important;
}
.person-item {
    display: flex;
    margin-bottom: 16px;
    justify-content: space-between;
    font-size: 12px;

    .person-item_name {
        width: 30px;
        height: 30px;
        text-align: center;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 55%;
        margin-right: 16px;
    }

    .person-item_detail {
        line-height: 16px;

        .item_detail--dept {
            font-size: 12px;
            color: #bfc3c7;
        }
    }

    .person-item_close {
        line-height: 30px;
        font-size: 14px;
    }
}
.dept-item {
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
    font-size: 12px;
    align-items: center;

    .dept-item_detail {
        line-height: 16px;
    }

    .dept-item_close {
        line-height: 16px;
        font-size: 14px;
    }
}
::v-deep .el-input__inner {
    width: 100% !important;
}
.tree-div {
    /* margin:  0 20px; */
    margin-right: 20px;
}
/deep/ .prepend-css .el-input__inner {
    border: 1px solid #dcdfe6 !important;
    border-left: none !important;
    border-radius: 0 3px 3px 0 !important;
}
.el-input-group__prepend {
    border-radius: 3px 0 0 3px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Tree/personDeptTree.vue